import React from 'react';
import { motion } from 'framer-motion';
import { Copyright, Instagram, Facebook } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-pink-600 to-purple-700 text-white py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h3 className="text-2xl font-bold mb-4 bg-white bg-clip-text text-transparent">Ratones Viajeros</h3>
          
          <div className="flex justify-center space-x-6 mb-6">
            <a href="#" className="p-2 bg-white/20 rounded-full hover:bg-white/30 transition-colors">
              <Instagram size={20} />
            </a>
            <a href="#" className="p-2 bg-white/20 rounded-full hover:bg-white/30 transition-colors">
              <Facebook size={20} />
            </a>
          </div>
          
          <p className="text-sm text-white/90 mb-4">
            &copy; 2026 Ratones Viajeros. Todos los derechos reservados. Haciendo viajes mágicos accesibles.
          </p>
          
          <p className="flex items-center justify-center text-sm text-white/80 space-x-1">
            <Copyright size={16} />
            <span>Diseñado con amor para aventuras épicas</span>
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;